var _path, _path2, _path3, _path4, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96,192h128v-32h-32V96c0-53-43-96-96-96S0,43,0,96S43,192,96,192z M96,32c35.3,0,64,28.7,64,64v64H96 c-35.3,0-64-28.7-64-64S60.7,32,96,32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352,192h64c53,0,96-43,96-96S469,0,416,0s-96,43-96,96v192h32V192z M352,96c0-35.3,28.7-64,64-64 s64,28.7,64,64s-28.7,64-64,64h-64V96z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M416,320H288v32h32v64c0,53,43,96,96,96s96-43,96-96S469,320,416,320z M416,480c-35.3,0-64-28.7-64-64v-64 h64c35.3,0,64,28.7,64,64S451.3,480,416,480z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160,320H96c-53,0-96,43-96,96s43,96,96,96s96-43,96-96V224h-32V320z M160,416c0,35.3-28.7,64-64,64 s-64-28.7-64-64s28.7-64,64-64h64V416z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 160,
    width: 32,
    height: 32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 320,
    width: 32,
    height: 32
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommand);
export default __webpack_public_path__ + "static/media/command.4e6d26ae6d883a3fd7fa051cfaa89f80.svg";
export { ForwardRef as ReactComponent };